


















































































































































































































































































































































































































































































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import ProductOptionGuide from '@/components/product/ProductOptionGuide.vue';
import ProductSetOptionAddForm from '@/components/product/ProductSetOptionAddForm.vue';
import {readExcelFile} from '@/utils/excel';
import {Option, CustomerDemands, OptionImage, CustomerDemand, OptionMapping} from 'supporter';
import {getStorageByName} from '@/utils/excel';
import {ncpJoin,popupResize} from '@/utils/ncp';
import {ncpPopup, getCurrency} from '../../utils/commonUtils';
import { GetOptionsMallOptionNoRequest } from 'ncp-api-supporter/dist/types';
import { MallOption } from 'ncp-api-supporter/dist/types/modules/product/option';
import { changeDateFormat } from '@/utils/dateUtils';
import { pattern } from '@/const/regex';
const SEPARATOR = '|';
const extraManagementCdRegex = new RegExp(pattern['extra-management-cd'], 'g');

const updateOptionProperty = (optionItem, newOptionItem, property) => {
  if (newOptionItem[property].length) {
    return newOptionItem[property];
  }

  if (newOptionItem[property] === '') {
    return optionItem[property];
  }

  return '';
};

const mergeOptionObjects = (optionsList, newOptionList) => {
  const mergedOptions = [];

  for (let i = 0; i < newOptionList.length; i++) {
    if (
      optionsList[i]?.optionName === newOptionList[i].optionName &&
      optionsList[i]?.optionValue === newOptionList[i].optionValue
    ) {
      const comparableProps = ['addPrice', 'purchasePrice', 'stockCnt', 'optionManagementCd'];
      const mergedOptionItem = comparableProps.reduce((obj, propName) => {
        obj[propName] = updateOptionProperty(optionsList[i], newOptionList[i], propName);
        return obj;
      }, {});
      mergedOptions.push({
        optionName: newOptionList[i].optionName,
        optionValue: newOptionList[i].optionValue,
        ...mergedOptionItem,
      });
    } else if (
      !optionsList[i] ||
      optionsList[i].optionName + optionsList[i].optionValue !==
        newOptionList[i].optionName + newOptionList[i].optionValues
    ) {
      mergedOptions.push(newOptionList[i]);
    }
  }

  return mergedOptions;
};

@Component({components: {ProductOptionGuide, ProductSetOptionAddForm}})
export default class ProductOptionAddForm extends Vue {
  private saleSettingStatusType = 'AVAILABLE_FOR_SALE';
  private optionGuide = false;
  private standardOptions: Option[] = [];
  private combinationOptions: Option[] = [];
  private customerDemands: CustomerDemands[] = [];
  private optionsTemplates: any[] = [];
  private optionsList: any[] = [];
  private optionType = 'COMBINATION';
  private batchUseYn = 'Y';
  private batchSaleStatus = 'AVAILABLE';
  private batchStock = '';
  private batchReservationStock = '';
  private batchPrice = '';
  private selectedOption: number[] = [];
  private transformed = false;
  private isSetCanceled = false;
  private callback: any = null;
  private mallNo = 0;
  private deliveryTemplateNo = 0;
  private setOptions: any[] = [];
  private mallProductNo = 0;
  private options = [];
  private confirmed = false;
  private getCurrency = getCurrency;
  private useReservationStock = false;
  private masterYn = '';
  private isStockSync = false;
  private salePrice = 0
  private discountPrice = 0
  private commissionRate = 0
  private alerted = false
  private stockInfo: MallOption[] = []
  private imageButtonIndexes:number[] = [];
  private isPurchasePrice = this.$route.query.commissionRateType === 'PURCHASE_PRICE'
  private downloadOptionListMallProductNo = ''

  getSaleStatusLabel(stockCnt: string) {
    return Number(stockCnt) > 0 ? window.$t('PRODUCT_OPTION_SALE_ABLE') : window.$t('PRODUCT_OPTION_SOLD_OUT');
  }
  get minOptionPrice(){ 
    return -(this.salePrice - this.discountPrice);
  }

  private getStockValue(index: number, key: 'safetyStockCnt' | 'deliveryWaitingStockCnt'): number | string{
    return this.stockInfo?.[index]?.[key] || '-'
  }

  private async getProductsMallProductNoOptions(mallOptionNo?: number){
    try {
      const request: GetOptionsMallOptionNoRequest = {
        params: {
          mallOptionNo: mallOptionNo.toString()
        }
      }

      const { data: { mallProductNo } }= await this.$api.getOptionsMallOptionNo(request);
      const { data } = await this.$api.getProductsMallProductNoOptions({params: {mallProductNo: mallProductNo.toString()}});

      this.downloadOptionListMallProductNo = mallProductNo.toString()

      return data;
    } catch (e) {
      console.error(e)
    }
  }

  private async downloadOptionList(){
    if(!this.optionsList.length){
      alert(this.$t('PRODUCT_OPTION_EMPTY_OPTION_DATA'));
      return;
    }

    if (!this.downloadOptionListMallProductNo.length) {
      alert(this.$t('PRODUCT_OPTION_NO_EXCEL_DB'));

      return;
    }

    try {
      const response = await this.$api.getProductsMallProductNoOptionsExcel({
        params: {mallProductNo: this.downloadOptionListMallProductNo},
        responseType: 'blob'
      })
      const myBlob = new Blob([response.data], {type: 'application/octet-stream'});
      const qrUrl = window.URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = `${this.downloadOptionListMallProductNo}_옵션다운로드_${changeDateFormat(new Date(), 'YYYYMMDDHHMM')}.xlsx`;
      a.href = qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(qrUrl);
    } catch (e) {
      alert(e);
    }
  }

  get moduleLength() {
    let length = 0;

    this.optionsTemplates.forEach((template, index) => {
      if (index) {
        length = index === 1 ? 0 : length;
        length = length ? length * template.optionValue.split(',').length : template.optionValue.split(',').length;
      } else {
        length = template.optionValue.split(',').length;
      }
    });

    return length;
  }

  private sampleDownload() {
    const fileName = 'option_combination_sample_20230823.xlsx';
    const showName = `옵션 대량등록_업로드양식_${changeDateFormat(new Date(), 'YYYYMMDD')}.xlsx`;
    getStorageByName(fileName, showName);
  }

  private addExcel() {
    try {
      if (this.options.length && !confirm(window.$t('PRODUCT_OPTION_SURE_REGISTER_DELETE'))) return;

      const file = Array.from((this.$refs.addExcelFile as HTMLInputElement).files as FileList)[0];
      if (!file.name.toLowerCase().match(/\.(xlsx)$/)) {
        throw window.$t('PRODUCT_OPTION_TIP_ONLY_EXCEL');
      }
      const keyMapJson = {
        optionName: window.$t('PRODUCT_OPTION_OPTION_NAME'),
        optionValue: window.$t('PRODUCT_OPTION_OPTION_VALUE'),
        addPrice: window.$t('PRODUCT_OPTION_OPTION_PRICE'),
        purchasePrice: window.$t('PRODUCT_OPTION_PRODUCT_PRICE'),
        stockCnt: window.$t('PRODUCT_OPTION_STOCK_CNT'),
        optionManagementCd: window.$t('PRODUCT_OPTION_OPTION_MANAGE'),
        extraManagementCd: window.$t('PRODUCT_OPTION_EXTRA_MANAGEMENT_CODE'),
        mainImageUrl: window.$t('PRODUCT_OPTION_REPRESENT_IMG'),
        detailImageUrl: window.$t('PRODUCT_OPTION_DETAIL_IMG'),
        useYn: window.$t('PRODUCT_OPTION_USEYN')
      };
      readExcelFile(file, keyMapJson, (excelData: any) => {
        excelData = excelData.map(data=>{
          data.addPrice = parseInt(data.addPrice);
          return data
        })
        try {
          const optionKeys = Object.keys(excelData[0]);
          const optionType = optionKeys.includes('addPrice') || optionKeys.includes('stockCnt') ? 'COMBINATION' : 'STANDARD';
          const keys =
            optionType === 'STANDARD'
              ? ['optionName', 'optionValue', 'mainImageUrl', 'detailImageUrl', 'useYn']
              : ['optionName', 'optionValue', 'addPrice', 'purchasePrice', 'stockCnt', 'optionManagementCd', 'extraManagementCd','mainImageUrl', 'detailImageUrl', 'useYn'];
          const optionNameArr = optionKeys.filter((key: any) => !keys.includes(key)).map((key: any) => key);
          
          const optionName = ncpJoin(optionNameArr, SEPARATOR);

          if (optionNameArr.length > 5) {
            alert(window.$t('PRODUCT_OPTION_TIP_MAX_5'));
            return;
          }

          optionNameArr.forEach((name) => {
            this.checkOptionNameValidation(name, true);
          });

          if (optionType === 'COMBINATION' && !optionName) {
            alert(window.$t('PRODUCT_OPTION_TIP_OPTION_NAME_CORRECT'));
            return;
          }
          this.optionType = optionType;
          if (optionType === 'COMBINATION') {
            const template: any[] = [];

            optionNameArr.forEach((name: any) => {
              const set = new Set<string>();
              excelData.forEach((option: any) => {
                set.add(option[name]);
              });
              template.push({optionName: name, optionValue: Array.from(set).join(','), addPrice: '', purchasePrice: '', stockCnt: '', optionManagementCd: '', extraManagementCd: ''});
            });
            const combinationOptions = [];

            if(!this.isPurchasePrice){
              excelData.forEach(option => {
                delete option.purchasePrice;
              })
            }

            const optionMap = new Map();
            this.options.forEach(option => {
              const key = option.optionName + option.optionValue;
              optionMap.set(key, option);
            })

            excelData.forEach(option => {
              const valueArr = optionNameArr.map(name => option[name]);
              const imageUrlArr = `${option.detailImageUrl}`.replace(/\r\n/g, SEPARATOR).split(SEPARATOR);
              let order = 1;
              const optionImages = imageUrlArr.filter(url => !!url && url != 'undefined').map(url => this.setOptionImage(0, url, 'N', order++));

              if (!!option.mainImageUrl && option.mainImageUrl != 'undefined') {
                optionImages.push(this.setOptionImage(0, option.mainImageUrl, 'Y', 1));
              }

              this.checkImageValidation(optionImages);

              option.optionImages = optionImages;
              option.deleteYn = 'N';
              option.isEdit = true;

            
              option.optionName = optionName;
              option.optionValue = ncpJoin(valueArr, SEPARATOR);

              const key = option.optionName + option.optionValue;
              if(optionMap.get(key)){
                const optionItem = optionMap.get(key);
                option.mallOptionNo = optionItem.mallOptionNo;
                option.reservationStockCnt = optionItem.reservationStockCnt;
                option.stockNo = optionItem.stockNo;
                option.optionImages = option.optionImages ? option.optionImages : optionItem.optionImages;
                option.addPrice = option.addPrice ? option.addPrice : optionItem.addPrice;
                option.purchasePrice = option.purchasePrice ? option.purchasePrice : optionItem.purchasePrice;
                option.stockCnt = option.stockCnt ? option.stockCnt : optionItem.stockCnt;
                option.optionManagementCd = option.optionManagementCd ? option.optionManagementCd : '';
                option.extraManagementCd = option.extraManagementCd ? option.extraManagementCd : '';
                option.useYn = option.useYn ? option.useYn : optionItem.useYn;
              } else {
                option.mallOptionNo = 0;
                option.reservationStockCnt = 0;
                option.stockNo = 0;
                option.optionImages = option.optionImages ? option.optionImages : [];
                option.addPrice = option.addPrice ? option.addPrice : 0;
                option.purchasePrice = option.purchasePrice ? option.purchasePrice : 0;
                option.stockCnt = option.stockCnt ? option.stockCnt : 0;
                option.optionManagementCd = option.optionManagementCd ? option.optionManagementCd : '';
                option.extraManagementCd = option.extraManagementCd ? option.extraManagementCd : '';
                option.useYn = option.useYn ? option.useYn : 'Y';
              }

              valueArr.forEach(value => {
                this.checkOptionValueValidation(value, true);
              });
              this.validatorCombinationOption(option);
              combinationOptions.push(option)
            });
            this.combinationOptions = combinationOptions;
            this.optionsTemplates = template;
            this.mergeOption();
            this.setImageButtonIndexes();
          } else {
            const template: any[] = [];
            const optionNames = new Set<string>();

            excelData.forEach((option: any) => {
              optionNames.add(option.optionName);
            });
            optionNames.forEach((optionName) => {
              const optionValues = new Set<string>();
              excelData.forEach((option: any) => {
                if (optionName === option.optionName) {
                  optionValues.add(option.optionValue);
                }
              });
              template.push({optionName, optionValue: Array.from(optionValues).join(','), addPrice: '', purchasePrice: '', stockCnt: '', optionManagementCd: '', extraManagementCd: ''});
            });
            this.optionsTemplates = template;
            this.templateToOption();
            this.$nextTick(() => {
              excelData.forEach((option: any, index: number) => {
                if (option.mainImageUrl) {
                  (this.standardOptions[index].optionImages as OptionImage[]).push({mainYn: 'Y', mallOptionImageUrl: option.mainImageUrl});
                }
                if (option.detailImageUrl) {
                  const images = option.detailImageUrl.replace(/\r\n/g, SEPARATOR).split(SEPARATOR);

                  images.forEach((image: any) => {
                    (this.standardOptions[index].optionImages as OptionImage[]).push({mainYn: 'N', mallOptionImageUrl: image});
                  });
                }
              });
            });
          }
        } catch (error) {
          alert(error);
        }
        (this.$refs.addExcelFile as HTMLInputElement).value = '';
      });
    } catch (e) {
      alert(e);
    }
  }

  validatorCombinationOption(option:any) {
    this.checkStockCntValidation(option.stockCnt);
    this.checkAddPriceValidation(option.addPrice);
    this.checkManagementCdValidation(option.optionManagementCd);
    this.checkExtraManagementCdValidation(option.extraManagementCd);
  }

  checkAddPriceValidation(value:any) {
    value?.toString().split(',').forEach((value) => {
      value = parseFloat(value);
      if (value >= 1000000000) {
        throw this.$t('PRODUCT_OPTION_PLEASE_UNDER_10_BILLION');
      } else if ( value && String(value).charAt(String(value).length - 1) != '0') {
        throw this.$t('PRODUCT_OPTION_TIP_OPTION_PRICE_10');
      } else if (value < 0) {
        // 마이너스 옵션 체크
        const maxMinusPrice = - (this.salePrice - this.discountPrice);
  
        // 마이너스 옵션일경우 즉시할인 체크
        if (value < maxMinusPrice) {
          throw this.$t('PRODUCT_ADD_MIN_ADDPRICE_ERROR');
        }
      }
    });
  }

  checkManagementCdValidation(value:any) {
    value?.toString().split(',').forEach((value) => {
      this.checkMaxLength('optionManagementCd', value);
    });
  }

  private checkExtraManagementCdValidation(value: string) {
    value?.toString().split(',').forEach((value) => {
      const MAX_CD_LENGTH = 45;
  
      if (value.length > MAX_CD_LENGTH) {
        throw this.$t('PRODUCT_OPTION_OVER_TEXT');
      }
  
      if (value.match(extraManagementCdRegex)) {
        throw this.$t('PRODUCT_OPTION_NOT_REGISTRATION_TEXT');
      }
    });
  }

  checkStockCntValidation(value:any) {
    value?.toString().toString().split(',').forEach((value) => {
      value = parseFloat(value);
      if (value >= 1000000000) {
        throw this.$t('PRODUCT_ADD_STOCK_MAX_MSG');
      }
    });
  }

  setOptionImage(imageNo: number, imageUrl:string, mainYn:string, displayOrder:number, imageId?:string) {
    return {
      mallOptionImageNo: imageNo,
      mallOptionImageUrl: imageUrl,
      mainYn,
      displayOrder: displayOrder,
      mallOptionImageId: imageId
    };
  }

  checkImageValidation(images) {
    const mainImage = images.filter(v => v.mainYn === 'Y');
    const detailImages = images.filter(v => v.mainYn === 'N');
    const fail = (mainImage.length === 0 && detailImages.length > 0) || (mainImage.length > 0 && detailImages.length === 0) || detailImages.length > 5;

    if (fail) {
      if(mainImage.length === 0){
        throw this.$t('PRODUCT_OPTION_IMAGE1');
      }else{
        throw this.$t('PRODUCT_OPTION_IMAGE2');
      }
    }
  }

  checkOptionValueValidation(value, isExcel){
    if (!value) {
      throw this.$t('PRODUCT_OPTION_TIP_OPTION_VALUE');
    }
    this.checkMaxLength('optionValue', value, isExcel);
  }

  validationOptionManagement(e:Event, option){
    const value = (e.target as HTMLInputElement).value;
    const regex = /[\\*?'"‘”`<>]/g; // 입력불가한 특수문자
    option.optionManagementCd = regex.test(value) ? value.replace(regex, '') : value;
  }

  private handleManagementCode (e:Event, option) {
    const { value } = (e.target as HTMLInputElement);
    option.extraManagementCd = value.replace(extraManagementCdRegex, '');
  }

  get optionsTemplatesCount() {
    return this.optionsTemplates.length;
  }
  get allCheckedOption() {
    if (this.optionType === 'COMBINATION') {
      return this.selectedOption.length === this.combinationOptions.length;
    } else {
      return this.selectedOption.length === this.standardOptions.length;
    }
  }
  set allCheckedOption(checked: boolean) {
    if (checked) {
      this.selectedOption = [];
      if (this.optionType === 'COMBINATION') {
        this.combinationOptions.forEach((item: any, index: number) => {
          this.selectedOption.push(index);
        });
      } else {
        this.standardOptions.forEach((item: any, index: number) => {
          this.selectedOption.push(index);
        });
      }
    } else {
      this.selectedOption = [];
    }
  }
  optionsTemplatesCountChange(e: Event) {
    const value = Number((e.target as HTMLInputElement).value);
    const count = value - this.optionsTemplates.length
    if(count < 0) {
      this.optionsTemplates.splice(count)
      return
    }
    let i = 0;
    for (i; i < count; i++) {
      this.optionsTemplates.push({optionName: '', optionValue: '', addPrice: '', purchasePrice: '', stockCnt: '', optionManagementCd: '', extraManagementCd: ''});
    }
  }
  get buyerInputsCount() {
    return this.customerDemands.length;
  }
  buyerInputsCountChange(e: Event) {
    const value = Number((e.target as HTMLInputElement).value);
    this.customerDemands = [];
    let i = 0;
    for (i; i < value; i++) {
      this.customerDemands.push({
        inputText: '',
        useYn: 'Y',
        matchingType: 'PRODUCT'
      });
    }
  }
  private addOptionTemplate() {
    if (this.optionsTemplates.length === 5) {
      alert(window.$t('PRODUCT_OPTION_TIP_MAX_5_OPTION'));
    } else {
      this.optionsTemplates.push({optionName: '', optionValue: '', addPrice: '', stockCnt: '', purchasePrice: '', optionManagementCd: '', extraManagementCd: ''});
    }
    this.setImageButtonIndexes();
  }
  private deleteOptionTemplate(index: number) {
    this.optionsTemplates.splice(index, 1);
    /**
     * '입력 내용 적용' 버튼 클릭 이후 에만 옵션 목록에 적용되어야 하여 주석 처리
     */
    // this.templateToOption()
  }
  private templateToOption() {
    if (!this.templateValidation()) {
      return;
    }
    if (!this.confirmed &&(this.standardOptions.length || this.options.length) && !confirm(window.$t('PRODUCT_OPTION_SURE_REGISTER_DELETE'))) {
      return;
    }
    this.confirmed = false;
    this.transformed = true;
    this.alerted = false
    this.selectedOption = [];
    try {
      if (this.optionType === 'COMBINATION') {
        let optionName = '';
        this.optionsTemplates = this.optionsTemplates.map((item: any) => {
          optionName += optionName ? SEPARATOR + item.optionName : item.optionName;
          let values = item.optionValue.split(',');
          let addPrices = String(item.addPrice).split(',');
          let purchasePrices = String(item.purchasePrice).split(',');
          addPrices.length = values.length;
          purchasePrices.length = values.length;
          item.purchasePrice = purchasePrices.map((purchasePrice) => (purchasePrice ? purchasePrice : '')).toString();
          item.addPrice = addPrices.map((addPrice) => (addPrice ? addPrice : '')).toString();
  
          this.validatorCombinationOption(item);
  
          return item;
        });
  
        this.combinationOptions = [];
        this.computedCombinationOptions = []
        this.mergeOption();
        this.combineOption(optionName);
        this.changeEmptyOption();
  
      } else {
        this.standardOptions = [];
        this.optionsTemplates.forEach((item, index) => {
          let values = item.optionValue.split(',');
          let purchasePrices = item.purchasePrice.split(',');
          if (!index) {
            item.addPrice = '0';
            item.stockCnt = '0';
            item.optionManagementCd = '';
          } else {
            item.addPrice += ',0';
            item.stockCnt += ',0';
          }
          values.forEach((value: string, index) => {
            this.standardOptions.push({
              optionImages: [],
              mallOptionNo: 0,
              optionValue: value,
              useYn: 'Y',
              addPrice: 0,
              purchasePrice: purchasePrices[index],
              optionName: item.optionName,
              stockCnt: 0,
              optionManagementCd: '',
              extraManagementCd: '',
              stockNo: 0
            });
          });
        });
      }
    } catch (err) {
      alert(err);
    }
  }
  private getHasTemplate(optionName: string) {
    const finded = this.optionsTemplates.find((template) => template.optionName === optionName);
    return !!finded;
  }

  private optionToTemplate() {
    if (this.optionType === 'STANDARD') {
      this.standardOptions.forEach((standardOption) => {
        if (!this.getHasTemplate(standardOption.optionName)) {
          let templateOptionValue = '';
          this.standardOptions.forEach((option) => {
            if (option.optionName === standardOption.optionName) {
              templateOptionValue = templateOptionValue ? templateOptionValue + ',' + option.optionValue : option.optionValue;
            }
          });
          this.optionsTemplates.push({
            optionName: standardOption.optionName,
            optionValue: templateOptionValue,
            addPrice: 0,
            purchasePrice: '',
            stockCnt: '',
            optionManagementCd: '',
            extraManagementCd: '',
          });
        }
      });
      this.transformed = true;
    } else {
      this.combinationOptions.forEach((combinationOption) => {
        const optionNameArr = combinationOption.optionName.split(SEPARATOR);
        optionNameArr.forEach((optionName, index) => {
          if (!this.getHasTemplate(optionName)) {
            const optionValueSet = new Set();

            this.combinationOptions.forEach((option) => {
              optionValueSet.add(option.optionValue.split(SEPARATOR)[index]);
            });
            const optionValueArr = Array.from(optionValueSet);
            this.optionsTemplates.push({
              optionName: optionName,
              optionValue: optionValueArr.toString(),
              addPrice: '',
              purchasePrice: '',
              stockCnt: '',
              optionManagementCd: '',
              extraManagementCd: '',
            });
          }
        });
      });

      this.optionsList = JSON.parse(JSON.stringify(this.optionsTemplates));
    }
  }

  changeEmptyOption(){
    const compareValues = ['addPrice','purchasePrice','stockCnt','optionManagementCd'];
    compareValues.forEach(compareValue => {
      this.checkEmptyProperty(this.combinationOptions, compareValue); 
    })
  }

  checkEmptyProperty(array, property) {
    let allEmpty = true;

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      if (obj[property]) {
        allEmpty = false;
      }
    }

    if (allEmpty) {
      this.changeOptionProperty(property)
    } else {
      return;
    }
  }

  changeOptionProperty(property){
    const originOptions = structuredClone(this.options);
    const newOptions = structuredClone(this.combinationOptions);
    newOptions.forEach(newOption => {
      const copyNewOption = structuredClone(newOption);
      const sameOption = originOptions.find(originOp => originOp.optionName === copyNewOption.optionName && originOp.optionValue === copyNewOption.optionValue);

      newOption[property] = sameOption ? sameOption[property] : newOption[property];
      
    });
    this.combinationOptions = newOptions;
  }

  combineOption(optionName){
    const optionProperty = [];
    const combineOptionResult = [];
    const alerted = this.alerted;
    const minOptionPrice = this.minOptionPrice;
    const $t = this.$t;

    this.optionsTemplates.forEach(optionsTemplate => {
      const {optionValue, addPrice, purchasePrice, stockCnt, optionManagementCd, extraManagementCd} = optionsTemplate;

      optionProperty.push({
        addedValue: optionValue.split(','),
        addedPrice: addPrice.split(','),
        addedPurchasePrice: purchasePrice.split(','),
        addedStockCnt: stockCnt.split(','),
        addedOptionManagementCd: optionManagementCd.split(','),
        addedExtraManagementCd: extraManagementCd.split(','),
        addedName: optionName,
      });
    })

    const combineOptionProperty = (combinedOptionArray, optionPropertyIdx, optionName) => {
      if(optionPropertyIdx + 1 <= optionProperty.length){
        optionProperty[optionPropertyIdx].addedValue.forEach((value, index) => {
          const {addedValue, addedPrice, addedPurchasePrice, addedStockCnt, addedOptionManagementCd, addedExtraManagementCd } = combinedOptionArray;

          combineOptionProperty({
            addedValue: addedValue ? addedValue.concat([value]) : [value],
            addedPrice: addedPrice ? addedPrice.concat([Number(optionProperty[optionPropertyIdx].addedPrice[index])]) : [Number(optionProperty[optionPropertyIdx].addedPrice[index])],
            addedPurchasePrice: addedPurchasePrice ? addedPurchasePrice.concat([Number(optionProperty[optionPropertyIdx].addedPurchasePrice[index])]) : [Number(optionProperty[optionPropertyIdx].addedPurchasePrice[index])],
            addedStockCnt: addedStockCnt ? addedStockCnt : ([Number(optionProperty[optionPropertyIdx].addedStockCnt[index])] ? [Number(optionProperty[optionPropertyIdx].addedStockCnt[index])] : ''),
            addedOptionManagementCd: addedOptionManagementCd ? addedOptionManagementCd : ([(optionProperty[optionPropertyIdx].addedOptionManagementCd[index])] ? [(optionProperty[optionPropertyIdx].addedOptionManagementCd[index])] : ''),
            addedExtraManagementCd: addedExtraManagementCd ? addedExtraManagementCd : ([(optionProperty[optionPropertyIdx].addedExtraManagementCd[index])] ? [(optionProperty[optionPropertyIdx].addedExtraManagementCd[index])] : ''),
            },
            
            optionPropertyIdx + 1,
            optionName
          );
        });
      } else  {
          const hasOriginOptionValue = (value) =>  this.options.some((optionItem) =>  (optionItem['optionName'] + optionItem['optionValue']) === value);
          const OriginOptionValue = (value) =>  this.options.filter((optionItem) => optionItem['optionValue'] === value);
          const sum = (array) =>array.reduce((accumulator, currentValue) => accumulator + currentValue);
          
          if (combinedOptionArray.addedPrice.some((optionPrice) => optionPrice < minOptionPrice) && !alerted) {
            this.alerted = true;
            alert($t('PRODUCT_ADD_MIN_ADDPRICE_ERROR'));
          }

          const optionValue = combinedOptionArray.addedValue.join(SEPARATOR);
          const originOptionValue = hasOriginOptionValue(optionName + optionValue) ? OriginOptionValue(optionValue)[0] : {};
          combineOptionResult.push({
            optionImages: originOptionValue.optionImages || [],
            optionValue,
            addPrice: sum(combinedOptionArray.addedPrice),
            purchasePrice: sum(combinedOptionArray.addedPurchasePrice),
            stockCnt: sum(combinedOptionArray.addedStockCnt),
            optionManagementCd: String(combinedOptionArray.addedOptionManagementCd || ''),
            extraManagementCd: String(combinedOptionArray.addedExtraManagementCd || ''),
            mallOptionNo: originOptionValue.mallOptionNo || 0,
            reservationStockCnt: originOptionValue.reservationStockCnt || 0,
            stockNo: originOptionValue.stockNo || 0,
            useYn: originOptionValue.useYn || 'Y',
            optionName
          });

          if (!this.alerted) {
            this.combinationOptions = [...combineOptionResult];
          }
          this.setImageButtonIndexes();
          return;
        }
    }

    combineOptionProperty('',0, optionName);
  }

  mergeOption(){
    if(!this.optionsList.length){  
      this.optionsList = this.optionsTemplates;
    } else{
      this.optionsList = mergeOptionObjects(this.optionsList, this.optionsTemplates);
    }
  }

  private computedCombinationOptions = []

  bindChangedOptionValue(index: number, valueIndex: number, e: Event) {
    const value = (e.target as HTMLInputElement).value;

    const values = this.combinationOptions[index].optionValue.split(SEPARATOR);
    values.splice(valueIndex, 1, value);
    this.combinationOptions[index].optionValue = values.join(SEPARATOR);
  }

  batchUpdate() {
    if (this.selectedOption.length) {
      if (this.optionType === 'COMBINATION' && this.combinationOptions.length) {
        this.selectedOption.forEach((index) => {
          if (this.batchPrice) {
            if (Number(this.batchPrice) % 10) {
              alert(window.$t('PRODUCT_OPTION_TIP_OPTION_PRICE_10'));
              return;
            }
            this.combinationOptions[index].addPrice = Number(this.batchPrice);
          }
          if (this.batchReservationStock) {
            this.combinationOptions[index].reservationStockCnt = Number(this.batchReservationStock);
          }
          if (this.batchStock) {
            this.combinationOptions[index].stockCnt = Number(this.batchStock);
          }
          if (this.batchSaleStatus && this.batchSaleStatus !== 'AVAILABLE') {
            this.combinationOptions[index].stockCnt = 0;
          }
          if (this.batchUseYn) {
            this.combinationOptions[index].useYn = this.batchUseYn as 'Y' | 'N';
          }
        });
      }
      if (this.optionType === 'STANDARD' && this.standardOptions.length) {
        this.selectedOption.forEach((index) => {
          if (this.batchUseYn) {
            this.standardOptions[index].useYn = this.batchUseYn as 'Y' | 'N';
          }
        });
      }
    } else {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SELECT_OPTION'));
    }
  }

  selectOption(index: number) {
    const findedIndex = this.selectedOption.indexOf(index);
    if (findedIndex >= 0) {
      this.selectedOption.splice(findedIndex, 1);
    } else {
      this.selectedOption.push(index);
    }
  }

  deleteOptionList() {
    if (this.selectedOption.length) {
      let isDeletableList = true;
      alert(window.$t('PRODUCT_OPTION_SELECTED') + this.selectedOption.length + window.$t('PRODUCT_OPTION_DELETE_OPTIONS'));

      if (this.optionType === 'COMBINATION') {
        this.selectedOption.forEach((combinationOptionsIndex, index) => {
          if (String(this.combinationOptions[combinationOptionsIndex].deletable) === 'false') {
            isDeletableList = false;
          }
        });
      } else {
        this.selectedOption.forEach((standardOptionsIndex, index) => {
          if (String(this.standardOptions[standardOptionsIndex].deletable) === 'false') {
            isDeletableList = false;
          }
        });
      }
      if (isDeletableList) {
        if (this.optionType === 'COMBINATION') {
          this.selectedOption.forEach((combinationOptionsIndex, index) => {
            this.combinationOptions.splice(combinationOptionsIndex - index, 1);
          });
        } else {
          this.selectedOption.forEach((standardOptionsIndex, index) => {
            this.standardOptions.splice(standardOptionsIndex - index, 1);
          });
        }
        this.selectedOption = [];
      } else {
        alert(this.$t('PRODUCT_OPTION_DELETABLE_N'));
      }
    } else {
      alert(window.$t('PRODUCT_OPTION_PLEASE_SELECT_DELETE'));
    }
    this.setImageButtonIndexes();
  }
  @Watch('optionType')
  changeOptionType(newVal: string) {
    if (this.transformed) {
      if (newVal === 'STANDARD' && this.combinationOptions.length) {
        const combinationOptions = this.combinationOptions;

        if (!confirm(window.$t('PRODUCT_OPTION_SURE_REGISTER_DELETE'))) {
          this.$nextTick(() => {
            this.optionType = 'COMBINATION';
            this.combinationOptions = combinationOptions;
            this.isSetCanceled = true;
          });
          return;
        }
      }
      const hasStandardOptionStockNo = this.standardOptions.some(option=>option.stockNo > 0);
      if (!this.isSetCanceled && !hasStandardOptionStockNo) {
        this.confirmed = true;
        this.standardOptions = [];
        this.templateToOption();
      }
      this.isSetCanceled = false;
    }
  }

  get priceIsLegal() {
    return this.priceValidation();
  }

  priceValidation() {
    let flag = true;
    this.optionsTemplates.forEach((template) => {
      if (template.addPrice && flag) {
        const prices = template.addPrice.split(',');
        prices.forEach((price: string) => {
          if (Number(price) % 10) {
            flag = false;
            return;
          }
        });
      }
    });
    return flag;
  }

  templateValidation() {
    let flag = true;
    if (this.combinationOptions.length) {
      const unDeletableOptions = this.combinationOptions.filter((combinationOption) => String(combinationOption.deletable) === 'false');
      if (unDeletableOptions.length) {
        alert(this.$t('PRODUCT_OPTION_DELETABLE_N'));
        flag = false;
        return;
      }
    }
    this.optionsTemplates.forEach((template) => {
      if (flag) {
        if (!template.optionName) {
          flag = false;
          alert(window.$t('PRODUCT_OPTION_TIP_OPTION_NAME_CORRECT'));
          return;
        }
        if (!template.optionValue) {
          flag = false;
          alert(window.$t('PRODUCT_OPTION_TIP_OPTION_VALUE'));
          return;
        }
        if (template.addPrice) {
          const prices = template.addPrice.split(',');
          prices.forEach((price: string) => {
            if (Number(price) % 10) {
              alert(window.$t('PRODUCT_OPTION_TIP_OPTION_PRICE_10'));
              flag = false;
              return;
            }
          });
        }
      }
    });
    return flag;
  }

  deleteBuyInput(index: number) {
    this.customerDemands.splice(index, 1);
  }

  addBuyInput() {
    if (this.customerDemands.length < 5) {
      this.customerDemands.push({
        inputText: '',
        useYn: 'Y',
        matchingType: 'PRODUCT'
      });
    } else {
      alert(window.$t('PRODUCT_OPTION_TIP_MAX_5_OPTION'));
    }
  }

  saveOption() {
    if (!this.saveValidation()) {
      return;
    }
    let options: any = null;
    if (this.optionType === 'COMBINATION') {
      const optionName = this.optionsList.map((option) => option.optionName).join('|');
      options = this.combinationOptions.map((combinationOption) => {
        combinationOption.optionName = optionName;
        return combinationOption;
      });
    } else {
      options = this.standardOptions;
    }
    const customerDemands = this.customerDemands;
    if (this.mallProductNo) {
      const params = {mallProductNos: '' + this.mallProductNo};
      const data: any = {
        optionType: this.optionType,
        options,
        customerDemands
      };
      this.$api.patchProducts({params, data}).then(() => {
        alert(window.$t('PRODUCT_OPTION_TIP_SAVED'));
        window.opener.postMessage({modifyOption: true});
        window.close();
      });
    } else {
      window.opener[this.callback] && window.opener[this.callback](options, customerDemands, this.optionType);
      window.close();
    }
  }

  saveValidation() {
    let isLegal = true;
    let count = 0;
    let addPriceZeroCount = 0;
    this.alerted = false
    if (this.optionType === 'COMBINATION') {
      this.combinationOptions.forEach((combinationOption) => {
        if (isLegal) {
          if (Number(combinationOption.addPrice) % 10) {
            alert(window.$t('PRODUCT_OPTION_TIP_OPTION_PRICE_10'));
            isLegal = false;
            return;
          }
          if (!combinationOption.optionValue) {
            alert(window.$t('PRODUCT_OPTION_TIP_OPTION_VALUE'));
            isLegal = false;
            return;
          }
        }
        if (combinationOption.useYn === 'Y') {
          count++;
          if (!Number(combinationOption.addPrice)) {
            addPriceZeroCount++;
          }
        }
      });
      this.optionsList.forEach((option) => {
        if(!option.optionName) {
        alert(window.$t('PRODUCT_OPTION_TIP_OPTION_NAME_CORRECT'));
        isLegal = false;
        return;
        }
      })
      if (!addPriceZeroCount && this.combinationOptions.length) {
        if (isLegal) {
          alert(window.$t('PRODUCT_OPTION_TIP_USEYN_Y_VALUE_0'));
          isLegal = false;
        }
      }
      this.combinationOptions = this.combinationOptions.map((combinationOption) => {
        if(combinationOption.addPrice < this.minOptionPrice){
          if(!this.alerted){
            this.alerted = true;
            alert(this.$t('PRODUCT_ADD_MIN_ADDPRICE_ERROR'));
          }
          isLegal = false;
        }
        return combinationOption
      });
    } else {
      const hasStandardOptionY = this.standardOptions.some((standardOption) => standardOption.useYn === 'Y');

      if (hasStandardOptionY) {
        alert(window.$t('PRODUCT_OPTION_TIP_INVALID_SINGLE'));
        isLegal = false;
        return;
      }
    }
    this.customerDemands.forEach((buyerInput) => {
      if (buyerInput.useYn === 'Y') {
        count++;
      }
      if (isLegal) {
        if (!buyerInput.inputText) {
          alert(window.$t('PRODUCT_OPTION_PLEASE_BUYER_NAME_CORRECT'));
          isLegal = false;
          return;
        }
      }
    });

    if (!count) {
      if (isLegal) {
        alert(window.$t('PRODUCT_OPTION_TIP_USEYN_Y'));
        isLegal = false;
      }
    }

    return isLegal;
  }
  init() {
    if (this.$route.query.dataCallback) {
      this.callback = this.$route.query.dataCallback;
    }
    if (this.$route.query.masterYn) {
      this.masterYn = this.$route.query.masterYn as string;
    }
    if (this.$route.query.isStockSync) {
      this.isStockSync = this.$route.query.isStockSync === 'true';
    }
    if (this.$route.query.salePrice) {
      this.salePrice = Number(this.$route.query.salePrice);
    }
    if (this.$route.query.discountPrice) {
      this.discountPrice = Number(this.$route.query.discountPrice);
    }
    if (this.$route.query.commissionRate) {
     this.commissionRate = Number(this.$route.query.commissionRate);
    }
    if (this.$route.query.mallNo) {
      this.mallNo = JSON.parse(this.$route.query.mallNo as string);
    }

    if (this.$route.query.deliveryTemplateNo) {
      this.deliveryTemplateNo = Number(this.$route.query.deliveryTemplateNo);
    }
    if (this.$route.query.optionType) {
      if (this.$route.query.optionType === 'STANDARD' || this.$route.query.optionType === 'COMBINATION' || this.$route.query.optionType === 'MAPPING') {
        this.optionType = this.$route.query.optionType as string;
      }
    }
    if (this.$route.query.mallProductNo) {
      this.mallProductNo = Number(this.$route.query.mallProductNo);
      this.saleSettingStatusType = this.$route.query.saleSettingStatusType as string;
      if (this.mallProductNo) {
        this.searchOption();
      }
    }
    if (this.$route.query.saleSettingStatusType) {
      this.saleSettingStatusType = this.$route.query.saleSettingStatusType as string;
    }
    /**
     * 옵션 등록시 options는 기본 true 같음
     * 처음 옵션 추가일 경우 sessionstorage에 옵션은 빈 배열[]
     * SalesInfomation에서 sessionStorage 생성
     * */
    if (this.$route.query.options) {
      const options = JSON.parse(sessionStorage.getItem('options'));
      this.options = options;
      // 옵션값이 있는지 확인 하는 것이 아니라
      // 무조건 true가 된다.
      /**
       * optionType이 mapping 일 경우가 언제 일까?
       * default: 옵션 사용안함
       * combination: 조합형
       * mapping: (프리미엄 전용)
       * */
      if (this.optionType === 'MAPPING') {
        this.setOptions = options;
      } else {
        this.loadOption(options).then(() => {
          this.toggleReadOnly();
        });
      }
    }

    if (this.$route.query.customerDemands) {
      const customerDemands = JSON.parse(this.$route.query.customerDemands as string);
      if (customerDemands) {
        this.loadBuyerInput(customerDemands);
      }
    }
    // 예약재고 사용여부
    if (this.$route.query.useReservationStock) {
      this.useReservationStock = this.$route.query.useReservationStock ==='true';
    }
  }
  toggleReadOnly() {
    if (this.saleSettingStatusType === 'PROHIBITION_SALE' || this.$route.query.readonly === 'true' || this.$route.query.targetId === 'judgement_optionData') {
      this.setDisabled(['.content input', '.content select', '.content button'], ['.content button']);
    }
    // 재고 연동 상품일경우
    if (this.isStockSync) {
      this.setDisabled(
        ['#inputTbody input[type=text]:not(.noSyncToggle)', '.optionTypeRadio', '.templateSelect:not(.noSyncToggle)'],
        ['#headerBtn', '#applyOptionBtn', '#removeOptionBtn', '.removeOptionLineBtn:not(.noSyncToggle)', '.addOptionLineBtn:not(.noSyncToggle)']
      );
      // slave 상품일경우
      if (this.masterYn !== 'Y') {
        this.setDisabled(
          ['.content input:not(.optionCheck):not(.allCheck):not(.noSyncToggle)', '.content select:not([name=useYn]):not(.noSyncToggle)', '.content button:not(.actionBtn):not(.noSyncToggle)'],
          ['.content button:not(.actionBtn):not(.noSyncToggle):not(.optionImageAddBtn)']
        );
      }
    }
  }
  setDisabled(targetTagList, hideTargetList) {
    targetTagList.forEach((targetTag) => {
      $(targetTag).each((i, target) => {
        $(target).prop('disabled', true);
      });
    });

    hideTargetList.forEach((hideTarget) => {
      $(hideTarget).each((i, target) => {
        $(target).hide();
      });
    });

    popupResize();
  }
  created() {
    this.init();
    this.$nextTick(()=>{
      this.setImageButtonIndexes();
    })
  }

  searchOption(productNo?: number) {
    this.$api.getProductsMallProductNoOptions({params: {mallProductNo: String(productNo ? productNo : this.mallProductNo)}}).then((res) => {
      this.options = res.data;
      let options = res.data;

      if (this.optionType === 'MAPPING') {
        options = options.map((option) => {
          let addPrice = 0;
          let minStock = 0;
          (option.mappings as OptionMapping[]).forEach((mapping, index) => {
            addPrice = addPrice + mapping.mappingOptionSalePrice;
            const stock = Math.round(mapping.itemStockCount / mapping.mappingCnt);
            if (!index) {
              minStock = stock;
            } else {
              minStock = minStock > stock ? stock : minStock;
            }
          });
          option.addPrice = addPrice;
          option.stockCnt = minStock;
          return option;
        });
        this.setOptions = options;
      } else {
        this.loadOption(options).then(() => {
          this.toggleReadOnly();
        });
      }
    });
    if (this.optionType !== 'MAPPING') {
      this.$api.getProductsProductNoCustomerDemands({params: {productNo: String(productNo ? productNo : this.mallProductNo)}}).then((res) => {
        this.loadBuyerInput(res.data);
      });
    }
  }

  private async setStockInfo(){
    for (let option of this.combinationOptions) {
      if (!option.mallOptionNo) {
        return;
      }
    }

    const data = await this.getProductsMallProductNoOptions(this.combinationOptions[0].mallOptionNo);
    this.stockInfo = data;
  }

  async loadOption(options: any) {
    this.optionsTemplates = [];
    if (this.optionType === 'STANDARD') {
      this.standardOptions = options;
    } else {
      this.transformed = true;
      this.combinationOptions = options;
      await this.setStockInfo()
    }

    this.optionToTemplate();
  }
  loadBuyerInput(customerDemands: CustomerDemand[]) {
    customerDemands.forEach((customerDemand) => {
      this.customerDemands.push({
        inputText: customerDemand.inputText,
        useYn: customerDemand.useYn,
        matchingType: customerDemand.matchingType as 'OPTION' | 'PRODUCT',
        inputNo: customerDemand.inputNo
      });
    });
  }
  checkOptionNameValidation(value: any, isExcel: boolean) {
    if (!value) {
      alert(window.$t('PRODUCT_OPTION_TIP_OPTION_NAME_CORRECT'));
      return;
    }
    this.checkMaxLength('optionName', value, isExcel);
  }
  checkMaxLength(target: any, value: any, isExcel = false) {
    if (value) {
      value = '' + value;
      if (25 < value.length) {
        if (!isExcel) {
          throw window.$t('PRODUCT_OPTION_PLEASE_NAME_25')
        }
      } else if (value.includes(SEPARATOR)) {
        throw window.$t('PRODUCT_OPTION_TIP_SPECIAL_TEXT');
      }
    }
  }
  callbackOptionImageInfo(imageInfo: any) {
    (window as any).callbackOptionInfo = null;

    const optionImages: OptionImage[] = [];

    if (imageInfo.mainImage && imageInfo.mainImage.url) {
      optionImages.push({mainYn: 'Y', mallOptionImageUrl: imageInfo.mainImage.url});
    }

    const subImages = imageInfo.images.filter((img: any) => img.url);
    subImages.forEach((image: any) => {
      optionImages.push({mainYn: 'N', mallOptionImageUrl: image.url});
    });

    if (this.optionType === 'COMBINATION') {
      this.combinationOptions[imageInfo.index].optionImages = optionImages;
    } else {
      this.standardOptions[imageInfo.index].optionImages = optionImages;
    }
  }

  otherOptionLoad() {
    (window as any).callbackOtherOptionLoad = this.callbackOtherOptionLoad;
    ncpPopup(`/option/otherOptionLoad?mallNo=${this.mallNo}&mallProductNo=0&dataCallback=callbackOtherOptionLoad`, 'otherOptionLoad', 1048, 558);
  }
  callbackOtherOptionLoad(productNo: any) {
    (window as any).callbackOtherOptionLoad = null;
    this.searchOption(productNo);
  }
  addOptionImage(index: number) {
    (window as any).callbackOptionImageInfo = this.callbackOptionImageInfo;
    const images = this.optionType === 'COMBINATION' ? this.combinationOptions[index].optionImages : this.standardOptions[index].optionImages;
    ncpPopup(`/option/image/addForm?index=${index}&mallNo=${this.mallNo}&dataCallback=callbackOptionImageInfo&data=${JSON.stringify(images)}`, 'optionImageForm', 1046, 423);
  }
  imageBatchAdd() {
    let length = 0;
    if (this.optionType === 'COMBINATION') {
      length = this.combinationOptions.length;
    } else {
      length = this.standardOptions.length;
    }
    if (length) {
      (window as any).callbackOptionImageBatchInfo = this.callbackOptionImageBatchInfo;
      ncpPopup(`/option/image/batch/addForm?mallNo=${this.mallNo}&length=${length}&dataCallback=callbackOptionImageBatchInfo`, 'optionImageForm', 1024, 358);
    }
  }
  callbackOptionImageBatchInfo(imageInfo: any) {
    (window as any).callbackOptionImageBatchInfo = null;
    if (this.optionType === 'COMBINATION') {
      imageInfo.forEach((image: any) => {
        (this.combinationOptions[image.optionNo - 1].optionImages as OptionImage[]).push({mainYn: image.mainYn, mallOptionImageUrl: image.url});
      });
    } else {
      imageInfo.forEach((image: any) => {
        (this.standardOptions[image.optionNo - 1].optionImages as OptionImage[]).push({mainYn: image.mainYn, mallOptionImageUrl: image.url});
      });
    }
  }
  private inputError = {
    addPrice0: false,
    addPrice1: false,
    addPrice2: false,
    addPrice3: false,
    addPrice4: false,
    stockCnt0: false,
    stockCnt1: false,
    stockCnt2: false,
    stockCnt3: false,
    stockCnt4: false
  };
  templateOptionValueCheck(e: Event, index: number, isBlur: boolean = false) {
    const target = e.target as HTMLInputElement;
    let value = target.value;
    if (value.includes(',,')) {
      value = value.replace(',,', ',');
    }
    value = value === ',' ? '' : value;
    
    if (isBlur && value.lastIndexOf(',') === value.length - 1) {
      value = value.substring(0, value.lastIndexOf(','));
    }

    const optionTemplate = this.optionsTemplates[index];
    optionTemplate.optionValue = value;
    this.optionsTemplates[index] = optionTemplate;
  }
  templateNumberKeyupCheck(e: Event, index: number, haveMinus: boolean = false) {
    let inputRegExp = haveMinus ? new RegExp(/[^0-9-]+/g) : new RegExp(/[^0-9]+/g);
    const target = e.target as HTMLInputElement;
    let value = target.value;
    const name = target.name;
    const maxLength = $(target).data('maxLength') || 8;
    if (value.includes(',,')) {
      value = value.replace(',,', ',');
    }
    if (value.includes('-,')) {
      value = value.replace('-,', '');
    }
    value = value === ',' ? '' : value;
    let values = value.split(',');
    values = values.map((value) => {
      if (value.match(inputRegExp)) {
        value = value.replace(inputRegExp, '');
        this.inputError[name + index] = true;
      } else {
        this.inputError[name + index] = false;
      }
      if (haveMinus && value.indexOf('-') !== -1) {
        if (value.indexOf('-') === 0) {
          value = '-' + value.replace(/[^0-9]+/g, '');
        } else {
          value = value.replace(/[^0-9]+/g, '');
        }
      }
      if (value.length > maxLength) {
        value = value.substr(0, maxLength);
      }
      return value;
    });
    value = values.join(',');
    const optionTemplate = this.optionsTemplates[index];
    optionTemplate[name] = value;
    this.optionsTemplates[index] = optionTemplate;
  }
  templateNumberBlur(e: Event, index: number, priceIsLegal: boolean) {
    const target = e.target as HTMLInputElement;
    const name = target.name;
    if (priceIsLegal) {
      const optionTemplate = this.optionsTemplates[index];
      let tempValue = optionTemplate[name];
      tempValue = tempValue.split(',').map(str=>Number(str)).join(',');
      optionTemplate[name] = tempValue;
      this.optionsTemplates[index] = optionTemplate;

      if (tempValue.length === 1) {
        return;
      } else if (tempValue.lastIndexOf(',') === tempValue.length - 1) {
        tempValue = tempValue.substring(0, tempValue.lastIndexOf(','));
        optionTemplate[name] = tempValue;
        this.optionsTemplates[index] = optionTemplate;
      } else if (tempValue.lastIndexOf(',-') === tempValue.length - 2) {
        tempValue = tempValue.substring(0, tempValue.lastIndexOf(',-'));
        optionTemplate[name] = tempValue;
        this.optionsTemplates[index] = optionTemplate;
      }
    } else {
      target.focus();
    }
  }
  setComma(e: Event, index: number, haveMinus: boolean = false) {
    let value = (e.target as HTMLInputElement).value;
    const name = (e.target as HTMLInputElement).name;
    const maxlength = (e.target as HTMLInputElement).maxLength;
    const arr = value.split(',');
    value = arr.join('');
    const isOvertop = value.length > maxlength;
    if (!isOvertop) {
      let tempHaveMinus = value.indexOf('-') === 0 && haveMinus
      if (value.match(/[^0-9]+/g)) {
        value = value.replace(/[^0-9]+/g, '');
      }
      value = tempHaveMinus ? '-' + value : value
      if (this.optionType === 'COMBINATION') {
        this.combinationOptions[index][name] = value;
      } else {
        this.standardOptions[index][name] = value;
      }

      this.$forceUpdate();
    }
  }
  minusZeroToZero(e: Event, index: number){
    let value = (e.target as HTMLInputElement).value;
    const name = (e.target as HTMLInputElement).name;
    const arr = value.split(',');
    value = arr.join('')
    if(!Number(value)){
      value = arr.map(str=>Number(str)).join(',');
    }
    this.combinationOptions[index][name] = value;
  }
  getStockNo(stockNo:number){
    if(this.isStockSync){
      let icon = this.masterYn === 'Y' ? '(M)' : '(S)';
      return icon + stockNo
    }
    return stockNo
  }
  mounted(){
    $('body').addClass('product_option');
    $('body').on('mouseover', 'input[name=optionValue], input[name=optionManagementCd]', this.hoverValue);
    $('body').on('mouseleave', 'input[name=optionValue], input[name=optionManagementCd]', this.leaveValue);
  }
  beforeDestroy(){
    $('body').removeClass('product_option');
    $('body').off('mouseover', 'input[name=optionValue], input[name=optionManagementCd]');
    $('body').off('mouseleave', 'input[name=optionValue], input[name=optionManagementCd]');
  }
  hoverValue(e:Event){
    const value = $(e.target).val();
    $('body').append(this.getHoverGuideForm(value, $(e.target).offset()));
  }
  getHoverGuideForm(value, offset){
    if (value) {
      const top = offset.top + 25;
      const left = offset.left - 10;
      const valueArr = this.safeSplit(value, ',');
      const content = valueArr.map(v => `<ul> <div class="description">${v}</div> </ul>`).join('');
      const html = `<div class="notice_box hoverGuide break-all" style="top:${top}px; left:${left}px;">
                      ${content}
                    </div>`;

        return html;
    }

    return '';
  }
  safeSplit(text, regx) {
    return !text || text == '' ? [] : text.split(regx);
  }
  leaveValue(){
    $('body').find('.hoverGuide').remove();
  }

  private setImageButtonIndexes(){
    if(this.combinationOptions.length === 0){
      return;
    }

    let prevOptionValue = '';
    const imageBtnIndexes = [];
    this.combinationOptions.forEach((option, index)=>{
      const options = option.optionValue.split('|');
      const firstOptionValue = options[0];

      if (firstOptionValue === prevOptionValue) return;
      prevOptionValue = firstOptionValue;
      imageBtnIndexes.push(index);
    })

    this.imageButtonIndexes = [...imageBtnIndexes]
  }
}
